<div class="auth-page">
    <!-- <perfect-scrollbar style="max-width: 100%; max-height: 100%;" [config]="scrollconfig"> -->
    
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
<!-- </perfect-scrollbar> -->
</div>